import { useState } from 'react'
import { User } from '../../interfaces/User/UserWMS'
import { apiCall, ApiConfig } from '../../config/api'
import { DataGridElements } from '../../interfaces'
import { AxiosResponse } from 'axios'

const useUser = () => {
  const [users, setUsers] = useState<User[]>([])

  const [user, setUser] = useState<User>({
    userId: 0,
    userName: '',
    contactNumber: '',
    active: false,
    zones: [],
    userAlias: ''
  })

  const [error, setError] = useState<string | undefined>(undefined)

  const [loading, setLoading] = useState<boolean>(false)
  const [pageSize, setChangePageSize] = useState<number>(5)
  const [page, setChangePage] = useState<number>(0)
  const [totalItems, setTotalItems] = useState<number>(0)
  const [firstEffect, setFirstEffect] = useState<boolean>(true)

  const getUsersWMS = async (name?: string, pageSearch?: number) => {
    setLoading(true)
    const emailFilter = name ? `&email=${encodeURIComponent(name!)}` : ``
    const pageIndex = name && pageSearch === 0 ? 0 : page
    const url = `${ApiConfig.UserApi}?pageIndex=${pageIndex}&pageSize=${pageSize}${emailFilter}`

    apiCall('GET', url)
      .then(
        ({
          data: { items, totalItems }
        }: AxiosResponse<DataGridElements<User>>) => {
          setUsers(items)
          setError(undefined)
          setTotalItems(totalItems)
        }
      )
      .catch((response) => {
        let error: string =
          'No fue posible obtener la información solicitada. Intente nuevamente en un momento.'

        if (response.data?.message !== undefined) {
          error = response.data?.message
        }

        setError(error)
      })
      .finally(() => setLoading(false))
  }

  const getUserWMS = async (id: number) => {
    setLoading(true)

    const url = ApiConfig.UserApi + `/${id}`

    apiCall('GET', url)
      .then(({ data }) => {
        setUser(data)
        setError(undefined)
      })
      .catch(({ data: { message } }) => {
        const error =
          message ||
          'No fue posible obtener la información solicitada. Intente nuevamente en un momento.'
        setError(error)
      })
      .finally(() => setLoading(false))
  }

  const handleChangePage = (_event: unknown, newPage: number) => {
    setChangePage(newPage)
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setChangePageSize(parseInt(event.target.value, 10))
    setChangePage(0)
  }

  const handleReset = () => {
    setChangePage(0)
    setChangePageSize(5)
    setTotalItems(0)
    setUsers([])
  }

  return {
    loading,
    error,
    getUsersWMS,
    users,
    getUserWMS,
    user,
    setChangePage,
    setChangePageSize,
    pagination: {
      page: page,
      pageSize: pageSize,
      totalItem: totalItems
    },
    handleChangePage,
    handleChangeRowsPerPage,
    setFirstEffect,
    firstEffect,
    handleReset
  }
}

export default useUser
